import { FormlyFieldConfigTranslatable } from "../../../../shared/types/form";

export function getFormFields(): FormlyFieldConfigTranslatable[] {
  return [
    {
      fieldGroupClassName: "flex flex-col gap-5", // Managing the gap between the fields
      fieldGroup: [
        {
          key: "name",
          type: "text",
          props: {
            label: {
              en: "Name",
              fi: "Nimi",
              sv: "Namn",
              no: "Navn",
            },
            required: true,
          },
          expressions: {
            "props.disabled": (config) => config.options?.formState.disabled,
          },
        },
        {
          key: "userIds",
          type: "selectOrgUser",
          props: {
            multiselect: true,
            label: {
              en: "Users",
              fi: "Käyttäjät",
              sv: "Användare",
              no: "Brukere",
            },
            required: true,
            requiredAccessRolePermission: "canApproveProcesses",
          },
          expressions: {
            "props.disabled": (config) => config.options?.formState.disabled,
          },
        },
      ],
    },
  ];
}
